import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Dropdown, Option, Field, Textarea, Input, Button } from "@fluentui/react-components";
import { Add20Regular, Delete20Regular } from "@fluentui/react-icons";
import { ITEMS } from "../GenericComponent/GenericData/QueueServiceIntegrationItem";
export default function QueueServiceIntegration(props) {
  const { t } = useTranslation();
  const [newHeaderKey, setNewHeaderKey] = useState("");
  const [newHeaderValue, setNewHeaderValue] = useState("");

  const HTTP_METHODS = ["GET", "POST", "PUT", "DELETE", "PATCH"];

  const addHeader = () => {
    if (newHeaderKey.trim() && newHeaderValue.trim()) {
      const currentHeaders = props.queue.integrationParams?.headers || {};
      props.setQueue({
        ...props.queue,
        integrationParams: {
          ...props.queue.integrationParams,
          headers: {
            ...currentHeaders,
            [newHeaderKey]: newHeaderValue,
          },
        },
      });
      setNewHeaderKey("");
      setNewHeaderValue("");
    }
  };

  const removeHeader = (key) => {
    const currentHeaders = { ...(props.queue.integrationParams?.headers || {}) };
    delete currentHeaders[key];
    props.setQueue({
      ...props.queue,
      integrationParams: {
        ...props.queue.integrationParams,
        headers: currentHeaders,
      },
    });
  };

  return (
    <div className="add-queue-root" >
      <div style={{marginLeft:'25%', width: '60%'}}>
      {" "}
      <Field label={t("TYPE")} className="field-style">
        {" "}
        <Dropdown
          clearable
          className="service-integ-dropdown-inline"
          placeholder={t("SELECT_TYPE")}
          value={props.queue.integrationParams?.servicetype}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onOptionSelect={(_, data) => {

            props.setQueue((queue) => ({
              ...queue,
              integrationParams: {
                ...queue.integrationParams,
                servicetype: data.optionValue,
              },
            }));
          }}
        >
          {ITEMS.map((item, index) => (
            <Option key={index} value={item}>
            {t(`SERVICE_ITEM.${item.toUpperCase()}`)}
            </Option>
          ))}
        </Dropdown>
      </Field>
      {props.queue.integrationParams?.servicetype === "CRM" && (
        <>
        <Field label={t("CRM_NAME")} className="field-style">
          <Input
            placeholder={t("CRM_NAME")}
            value={props.queue.integrationParams?.CRMName}
            disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
            onChange={(event, data) => {
              props.setQueue({
                ...props.queue,
                integrationParams: {
                  ...props.queue.integrationParams,
                  CRMName: data.value,
                },
              });
            }}
            className="service-integ-dropdown-inline"
          />
        </Field>
        <Field label={t("CLOSE_CRM_POPUP_ON")} className="field-style">
          <Dropdown
            placeholder={t("SELECT_CLOSE_CRM_POPUP_ON")}
            value={t(`CRM_POPUP_CLOSE.${props.queue.closeCRMPopUpOn || "CALL_RING_END"}`)}
            selectedOptions={[props.queue.closeCRMPopUpOn || "CALL_RING_END"]}
            disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
            onOptionSelect={(_, data) => {
              props.setQueue({
                ...props.queue,
                closeCRMPopUpOn: data.optionValue,
              });
            }}
            className="service-integ-dropdown-inline"
          >
            <Option value="CALL_RING_END">{t("CRM_POPUP_CLOSE.CALL_RING_END")}</Option>
            <Option value="CALL_DISCONNECTED">{t("CRM_POPUP_CLOSE.CALL_DISCONNECTED")}</Option>
          </Dropdown>
        </Field>
        </>
      )}
      <Field label={t("URL")} className="field-style">
        <Textarea
          placeholder={t("URL")}
          style={{ minHeight: "120px" }}
          resize="both"
          value={props.queue.integrationParams?.serviceURL}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              integrationParams: {
                ...props.queue.integrationParams,
                serviceURL: data.value,
              },
            });
          }}
          className="service-integ-dropdown-inline"
        />
      </Field>

      {/* HTTP Method */}
      <Field label={t("METHOD")} className="field-style">
        <Dropdown
          placeholder={t("SELECT_METHOD")}
          value={props.queue.integrationParams?.method || "POST"}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onOptionSelect={(_, data) => {
            props.setQueue({
              ...props.queue,
              integrationParams: {
                ...props.queue.integrationParams,
                method: data.optionValue,
              },
            });
          }}
          className="service-integ-dropdown-inline"
        >
          {HTTP_METHODS.map((method) => (
            <Option key={method} value={method}>
              {method}
            </Option>
          ))}
        </Dropdown>
      </Field>

      {/* Headers */}
      <Field label={t("HEADERS")} className="field-style">
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
          {/* Existing Headers */}
          {props.queue.integrationParams?.headers && Object.entries(props.queue.integrationParams.headers).map(([key, value]) => (
            <div key={key} style={{ display: "flex", gap: "0.5rem", alignItems: "center", width: "100%" }}>
              <Input
              
                 className="input-header-service-integ-style"
                value={key}
                disabled
                style={{ flex: 1  }}
                placeholder="Key"
              />
              <Input
               className="input-header-service-integ-style"
                value={value}
                disabled
                style={{ flex: 1 }}
                placeholder="Value"
              />
              <Button
                appearance="secondary"
                icon={<Delete20Regular />}
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onClick={() => removeHeader(key)}
              />
            </div>
          ))}

          {/* Add New Header */}
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", width: "100%" }}>
            <Input
               className="input-header-service-integ-style"
              value={newHeaderKey}
              placeholder="Key"
              style={{ flex: 1 }}
              disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
              onChange={(e, data) => setNewHeaderKey(data.value)}
            />
            <Input
               className="input-header-service-integ-style"
              value={newHeaderValue}
              placeholder="Value"
              style={{ flex: 1 }}
              disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
              onChange={(e, data) => setNewHeaderValue(data.value)}
            />
            <Button
              appearance="primary"
              icon={<Add20Regular />}
              disabled={!newHeaderKey.trim() || !newHeaderValue.trim() || (props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate)}
              onClick={addHeader}
            />
          </div>
        </div>
      </Field>
      </div>
    </div>
  );
}
